import React from 'react';
import { Tags } from 'lucide-react';

export const BrandFilterBar = ({ data, selected, onSelect }) => {
    if (!data?.enabled) return null;
    const brands = (data.brands || []).filter(b => b.count > 0);
    if (brands.length === 0 && !data.no_brand_count) return null;

    const chipClass = (active) =>
        `flex items-center gap-2 px-4 py-2 rounded-full border transition-all whitespace-nowrap text-sm font-medium ${
            active
                ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white border-transparent shadow-md'
                : 'bg-white/80 dark:bg-slate-800/80 border-amber-200 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:border-amber-400 hover:bg-amber-50 dark:hover:bg-slate-700'
        }`;

    return (
        <div className="mb-6 bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm p-4 rounded-xl border border-amber-100 dark:border-slate-700" data-testid="brand-filter-bar">
            <div className="flex items-center gap-2 mb-3">
                <Tags className="h-4 w-4 text-amber-600 dark:text-amber-400" />
                <h3 className="font-semibold text-amber-800 dark:text-amber-400 text-sm">Марки</h3>
            </div>
            <div className="flex flex-wrap gap-2">
                <button
                    onClick={() => onSelect('')}
                    className={chipClass(!selected)}
                    data-testid="brand-chip-all"
                >
                    Всички марки
                </button>
                {brands.map((b) => (
                    <button
                        key={b.brand_id}
                        onClick={() => onSelect(b.slug)}
                        className={chipClass(selected === b.slug)}
                        title={b.description || b.name}
                        data-testid={`brand-chip-${b.slug}`}
                    >
                        {b.logo_url && (
                            <img src={b.logo_url} alt={b.name} className="h-6 w-6 rounded-full object-cover bg-white" />
                        )}
                        <span>{b.name}</span>
                        <span className={`text-xs px-1.5 py-0.5 rounded-full ${selected === b.slug ? 'bg-white/25' : 'bg-amber-100 dark:bg-slate-700 text-amber-700 dark:text-amber-400'}`}>
                            {b.count}
                        </span>
                    </button>
                ))}
                {data.no_brand_count > 0 && (
                    <button
                        onClick={() => onSelect('none')}
                        className={chipClass(selected === 'none')}
                        data-testid="brand-chip-none"
                    >
                        <span>Други</span>
                        <span className={`text-xs px-1.5 py-0.5 rounded-full ${selected === 'none' ? 'bg-white/25' : 'bg-amber-100 dark:bg-slate-700 text-amber-700 dark:text-amber-400'}`}>
                            {data.no_brand_count}
                        </span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default BrandFilterBar;
